import { Component, Input } from '@angular/core';

/**
 * Previsão de pontos do pedido na página "Compra aprovada": quantos pontos a
 * compra vai gerar quando o pagamento confirmar, e o aviso de que o crédito
 * pode demorar (fila). Só renderiza quando o register devolveu
 * `points_forecast` no offer — loja sem o programa de pontos não recebe o
 * campo e nada aparece. Tolerante por construção: shape inesperado resulta em
 * não renderizar, nunca em quebrar a página.
 */
@Component({
    selector: 'completed-points-forecast',
    templateUrl: './completed.points-forecast.component.html'
})
export class CompletedPointsForecastComponent {
    @Input() offer: any;

    public show(): boolean {
        return this.points() > 0;
    }

    public points(): number {
        const points = this.offer
            && this.offer.points_forecast
            && this.offer.points_forecast.points;

        return typeof points === 'number' && points > 0 ? points : 0;
    }

    public gracePeriodDays(): number {
        const days = this.offer
            && this.offer.points_forecast
            && this.offer.points_forecast.grace_period_days;

        return typeof days === 'number' && days > 0 ? days : 0;
    }

    public messageParams(): any {
        return { points: this.points() };
    }

    public graceParams(): any {
        return { days: this.gracePeriodDays() };
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/completed/points-forecast/completed.points-forecast.component.ts